// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VeeValidate from 'vee-validate'
import App from './App'
import store from './store'
import router from './router'
import { sync } from 'vuex-router-sync'
import VuesticPlugin from 'src/components/vuestic-components/vuestic-components-plugin'
import vuexI18n from 'vuex-i18n'
import locale from './store/locale'
import VuePersist from 'vue-persist'
import axios from 'axios'
import Vue2Filters from 'vue2-filters'

Vue.use(Vue2Filters)
Vue.use(VuesticPlugin)
Vue.use(BootstrapVue)
Vue.use(VuePersist)



axios.interceptors.request.use(function (config) {
  // console.log('AXIOS Config:', config)
  if (config.headers.common === undefined) {
    config.headers.common = {}
  }
  config.headers.common['Content-Type'] = 'application/json'
  config.headers.post['Content-Type'] = 'multipart/form-data'
  if (store.state.token) {
    config.headers.common['Authorization'] = 'Bearer ' + store.state.token
  }
  // console.log('Token:', store.state.token)
  config.headers.common['Accept'] = 'Token'
  return config
}, function (error) {
  return Promise.reject(error)
})

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status === 401) {
    if (router.currentRoute.path.match('invoice')) {
      console.log('Keep Path')
    } else if (error.response.request.responseURL.indexOf('mikipay.com') >= 0) {
      store.commit('logout')
      router.push({
        path: '/'
      })
      // window.location = '/'
    }
  } else {
    return Promise.reject(error)
  }
})

// NOTE: workaround for VeeValidate + vuetable-2
Vue.use(VeeValidate, {fieldsBagName: 'formFields'})
Vue.use(vuexI18n.plugin, store, {
  moduleName: 'i18n',
  onTranslationNotFound (locale, key) {
    console.warn(`i18n :: Key '${key}' not found for locale '${locale}'`)
  }})

// Vue.i18n.add('ru', locale.ru)
Vue.i18n.add('en', locale.en)
// Vue.i18n.add('he', locale.he)
Vue.i18n.set('en')

sync(store, router)

let mediaHandler = () => {
  if (window.matchMedia(store.getters.config.windowMatchSizeLg).matches) {
    store.dispatch('toggleSidebar', true)
  } else {
    store.dispatch('toggleSidebar', false)
  }
}

router.beforeEach((to, from, next) => {
  store.commit('setLoading', true)
  console.log('State: To => ', to, 'From => ', from)

  if (to.path.indexOf('/auth/logout') === 0 && store.state.token) {
    console.log('Rule 1')
    // store.commit('logout')
    router.push({
      path: '/auth/login'
    })
  }

  if (to.path.indexOf('/invoice') === 0) {
    console.log('Rule 111.1')
    next()
  }

  if (store.state.token && to.path.indexOf('/auth') === 0) {
    console.log('Rule 2')
    next({
      path: '/dashboard'
    })
  }

  if (to.matched.some(record => (record.meta.requiresAuth !== false))) {
    console.log('Rule 3')
    if (!store.state.token && to.path.indexOf('/invoice') !== 0) {
      console.log('Rule 3.1 ' + to.path)
      next({
        path: '/auth/login'
      })
    } else {
      console.log('Rule 3.2')
      next()
    }
  } else {
    console.log('Rule 3.3')
    next()
  }
})

router.afterEach((to, from) => {
  mediaHandler()
  store.commit('setLoading', false)
})

document.title = 'MikiPay'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js